/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from 'react';
import { Helmet } from "react-helmet-async";
import HeaderFour from '../../components/Header/HeaderFour';
import FooterTwo from '../../components/Footer/FooterTwo';
import Breadcrumb from '../../components/Breadcrumb';
import SectionTitle from '../../components/SectionTitle';

import Logo from '../../assets/img/logo/logo-white-2.png';

import Img1 from '../../assets/img/gallery/CB1.JPG';
import Img2 from '../../assets/img/gallery/CB2.JPG';
import Img3 from '../../assets/img/gallery/CB3.JPG';
import Img4 from '../../assets/img/gallery/CB4.JPG';
import Img5 from '../../assets/img/gallery/CB5.JPG';
import Img6 from '../../assets/img/gallery/CB6.JPG';
import Img7 from '../../assets/img/gallery/CB7.JPG';
import Img8 from '../../assets/img/gallery/CB8.JPG';

const Gallery = () => {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const images = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8];

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => setIsLightboxOpen(false);

  const goToNext = () => {
    setCurrentImageIndex((currentImageIndex + 1) % images.length);
  };

  const goToPrevious = () => {
    setCurrentImageIndex((currentImageIndex - 1 + images.length) % images.length);
  };

  return (
    <main>
      <Helmet>
      <title>Gallery | CBS HUB Central Books — Schools, Events & Products</title>
      <meta name="description" content="Browse the CBS HUB gallery: school partnerships, book fairs, supply deliveries and product showcases across Hyderabad, Telangana, AP and Pan-India." />
      <meta name="keywords" content="Central Books gallery, CBS HUB school photos, book fair gallery Hyderabad, school supply showcase India" />
      <link rel="canonical" href="https://www.centralbooks.in/gallery" />
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content="Gallery | CBS HUB Central Books — Schools, Events & Products" />
      <meta property="og:description" content="Browse the CBS HUB gallery: school partnerships, book fairs, supply deliveries and product showcases across Hyderabad, Telangana, AP and Pan-India." />
      <meta property="og:url" content="https://www.centralbooks.in/gallery" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.centralbooks.in/images/gallery-og.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Gallery | CBS HUB Central Books — Schools, Events & Products" />
      <meta name="twitter:description" content="Browse the CBS HUB gallery: school partnerships, book fairs, supply deliveries and product showcases across Hyderabad, Telangana, AP and Pan-India." />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.centralbooks.in/"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Gallery",
              "item": "https://www.centralbooks.in/gallery"
            }
          ]
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          "name": "CBS HUB Central Books Gallery",
          "url": "https://www.centralbooks.in/gallery",
          "description": "Photos of school partnerships, book fairs and supply operations"
        })}
      </script>
    </Helmet>
      <HeaderFour />
      <Breadcrumb title="CBS HUB Gallery — Schools, Book Fairs & Supply Operations" subTitle="Gallery" />
      <div className="it-wrok-area it-wrok-bg ed-work-style-2 pt-20 pb-120 grey-bg-4">
        <div className="container">
          <div className="row justify-content-center text-center mb-50 pt-60">
            <div className="col-xl-10">
              <h2 className="pb-20" style={{ fontSize: '2.2rem', fontWeight: '700' }}>School Partnerships Across Hyderabad, Telangana & India</h2>
              <h3 style={{ color: '#ea580c', fontSize: '1.6rem', fontWeight: '600' }}>Book Fair Events & Educational Product Showcases</h3>
            </div>
          </div>
          {/* <div className="row justify-content-center">
            <div className="col-xl-6">
              <SectionTitle
                itemClass="it-course-title-box mb-60 text-center"
                subTitleClass="it-section-subtitle-2 white-bg"
                subTitle="Gallery"
                titleClass="ed-section-title"
                title="Gallery"
              />
            </div>
          </div> */}
          <div className="gallery-container">
            {/* Gallery Grid */}
            <div className="gallery-grid">
              {images.map((img, index) => (
                <div
                  key={index}
                  className="gallery-item"
                  onClick={() => openLightbox(index)}
                >
                  <img src={img} alt={`Gallery ${index + 1}`} />
                </div>
              ))}
            </div>

            {/* Lightbox */}
            {isLightboxOpen && (
              <div className="lightbox-overlay">
                <button className="lightbox-close" onClick={closeLightbox}>
                  &times;
                </button>
                <button className="lightbox-prev" onClick={goToPrevious}>
                  &#10094;
                </button>
                <div className="lightbox-content">
                  <img
                    src={images[currentImageIndex]}
                    alt={`Image ${currentImageIndex + 1}`}
                  />
                </div>
                <button className="lightbox-next" onClick={goToNext}>
                  &#10095;
                </button>
                {/* Thumbnails */}
                <div className="lightbox-thumbnails">
                  {images.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      alt={`Thumbnail ${index + 1}`}
                      className={
                        currentImageIndex === index ? 'active-thumbnail' : ''
                      }
                      onClick={() => setCurrentImageIndex(index)}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <FooterTwo
        footerClass="it-footer-area it-footer-bg it-footer-style-5 ed-footer-style-5 inner-style black-bg pb-70"
        footerLogo={Logo}
        btnClass="it-btn-white sky-bg"
        copyrightTextClass="it-copyright-text inner-style text-center"
      />
    </main>
  );
};

export default Gallery;